<template>
  <div class="ggh-print-container">
    <div class="ggh-print-content">
      <div class="print-header">
        <span>{{merchname}} {{date}}货单</span>
      </div>
      <div class="print-list">
        <div
          :class="[page.currpage<2?'print-item':'print-item print-item2']"
          v-for="(page,index) in pages"
          :key="index"
        >
          <div class="item-list">
            <div :class="[index > 1 ?'item-title theader2':'item-title']">名称</div>
            <div :class="[index > 1 ?'item-title theader2':'item-title']">数量</div>
          </div>
          <div class="item-list" v-for="item in page">
            <div class="item-name">{{item.title}}</div>
            <div class="item-number">{{item.num}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrderModel } from "@models/common/order";
const orderModel = new OrderModel();
import { dateFormat } from "@util/functions";
import { ERR_OK } from "@/common";
export default {
  computed: {
    pages() {
      const pages = [];
      this.list.forEach((item, index) => {
        const page = Math.floor(index / 26);
        let currpage = Math.floor(index / 52) + 1;
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
        pages[page]["currpage"] = currpage;
      });
      return pages;
    }
  },
  data() {
    return {
      list: [],
      date: "",
      merchname: ""
    };
  },
  components: {},
  methods: {
    getData() {
      orderModel.getPrintSummary().then(res => {
          if(res.code == ERR_OK) {
            this.list = res.data.data
            this.merchname = this.$route.query.merchname
            this.date = dateFormat("YYYY.mm.dd", new Date());
          }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="stylus" scoped>
.ggh-print-container {
  background: #fff;
}

.theader2 {
  margin-top: 20px;
}

.remark {
  width: 120px;
  margin-top: -6px;
  font-size: 20px;
}

.ggh-print-content {
  max-width: 595px;
  min-height: 842px;
  margin: 0 auto;
  background: #fff;
  text-align: center;
}

.print-header {
  font-size: 24px;
  padding: 20px 0;
  font-weight: bold;
  text-align: center;
}

.print-list {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.print-item {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  width: 40%;
}

.item-name {
  font-size: 18px;
  font-weight: bold;
}

.item-title {
  font-weight: bold;
}

.print-item2 {
  margin-top: 80px;
  height: 959px;
}

.item-number {
  font-size: 23px;
  font-weight: bold;
}

.item-list {
  margin-bottom: 0.1rem;
  display: flex;
  width: 100%;
  line-height: 1.3;
  justify-content: space-between;
}
</style>
